<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Whitelisting" title="New Whitelisting Request" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

							<form @submit.prevent="fetchData" enctype="multipart/form-data">
								<div class="row">
									<div class="col-md-3">
										<div class="mb-3">
										<label class="control-label">ICCID/IMEI<span class="text-danger">*</span></label>
										<input class="form-control" type="text" v-model="po_number" placeholder=""/>
										</div>
									</div>

									<div class="col-md-2 align-items-end" style="margin-top: 33px;">
										<div class="mb-3">
											<button class="btn btn-warning me-2" type="submit">Submit</button>
										</div>
									</div>

								</div>
							</form>

							<div class="table-responsive mt-4" v-if="iccid">
								<div class="col-12 p-3" style="border: 1px dashed orange; border-radius: 6px;">
									<!-- Headings -->

									<!-- Numbers and IPs rows -->
									<div class="row mb-1" >
										<div class="col-md-6">
											<div class="table-responsive">
												<table class="table submit table-borderless table-sm mb-0">
													<tbody>
														<tr>
															<th scope="row" class="fw-bold" style="width: 300px;">ICCID:</th>
															<td class="fw-normal">{{ iccid }}</td>
														</tr>
														<tr>
															<th scope="row" class="fw-bold" style="width: 300px;">PRIMARY MSISDN:</th>
															<td class="fw-normal">{{ primary_msisdn }}</td>
														</tr>
														<tr>
															<th scope="row" class="fw-bold" style="width: 300px;">SECONDARY MSISDN:</th>
															<td class="fw-normal">{{ secondary_msisdn }}</td>
														</tr>
														<tr>
															<th scope="row" class="fw-bold" style="width: 300px;">DATA USAGE:</th>
															<td class="fw-normal">{{ data_usage }}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>

				</div>
			</div>
		</div>

   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "",
		
		data() {
	      
			return {
				po_number: '',
				iccid: '',
				primary_msisdn: '',
				secondary_msisdn: '',
				data_usage: '',


			};
		},
		mounted() {},

		created() {

		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},

			fetchData() {
				
				this.getToken();

				const config = {
					headers: {
						Accept: 'application/json',
						Authorization: 'Bearer ' + this.token, 
					},
				};

				let url = "/trazio/dataUsage?&value=" + this.po_number; 

				this.$axios
					.get(url, config)
					.then((res) => {
						const data = res.data.data; 
						this.iccid = data.primary_ICCID || '';
						this.primary_msisdn = data.primary_MSISDN || '';
						this.secondary_msisdn = data.secondary_MSISDN  || '';
					})
					.catch((err) => {
						console.error(err);
						this.$swal('Error', 'Failed to fetch whitelist data.', 'error');
					});
				
			}

			
		},
	};
</script>
